import React, {useState} from 'react'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export const RichTextEditor = ({placeholder,supportMultiMedia, value, onChange}) => {
    
    //Multimedia support to be implemented if the need arise
    //Can be implemeted for SEIMS CMS, for attaching videos and images 
    const modules = {
        toolbar: [
          [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
          [{size: []}],
          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, 
           {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'image', 'video'],
          ['clean']
        ],
        clipboard: {
          // toggle to add extra line breaks when pasting HTML:
          matchVisual: false,
        }
      }

    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'video'
      ]

    return (
        <div>
            <ReactQuill style={{height: "200px"}} modules={modules} formats={formats} placeholder={placeholder} theme="snow" value={value} onChange={onChange} />
        </div>
    )
}
